import type { ReactNode } from "react";
import { t } from "./kieli";

/**
 * Tilan esitys — yksi mekanismi, ei kuusi paikallista väriä.
 *
 * Toni 10.9.2026: brändiväri tulee asiakkaalta, joten sen törmäys
 * tilaväreihin on rakenteellinen eikä valinta. Sampon oma vihreä
 * (#35882B) on käytännössä sama sävy kuin tuotteen entinen `--ok`
 * (#2d7825) — «kunnossa» olisi lakannut erottumasta brändistä. Sitä
 * ei ratkaista paremmalla vihreällä vaan sillä, ettei kunnossa oleva
 * tarvitse väriä lainkaan: Sampo näyttää poikkeamat.
 *
 * Kolme tilaa, kolme muotoa, eikä yksikään nojaa pelkkään väriin:
 *
 *   kunnossa    neutraali muste, ARVO NÄKYVISSÄ («8 / 8», «voimassa
 *               14.3.2027»). Ei väriä, ei merkkiä, ei tyhjää.
 *   poikkeama   väri JA sana JA muoto («vanhentunut 12 vrk», «2
 *               puuttuu»); kaksi astetta: varoitus ja vika.
 *   ei_mitattu  oma sanansa vaimennettuna («ei tietoa», «ei mitattu»).
 *               Ei koskaan tyhjä ruutu.
 *
 * Kunnossa erottuu siitä että siinä on luku: luku kertoo havainnon,
 * vihreä pallo mielipiteen. Ja «kunnossa on hiljainen» EI saa tarkoittaa
 * «näyttää samalta kuin ei mitattu» — muuten kaksi tilaa romahtaa yhdeksi
 * (sama vika kuin tyhjä eräpäivä listan alussa). Siksi sisältö on
 * pakollinen ja ei_mitattu saa aina sanan.
 *
 * `--ok` on tyylit.css:ssä yhä olemassa, mutta se on nyt muste: unohtunut
 * käyttöpaikka ei ala vihertää hiljaa.
 */
export type Tilalaji = "kunnossa" | "varoitus" | "vika" | "ei_mitattu";

/** Väri tokenina niille paikoille jotka piirtävät itse (palkit, reunat). */
export const TILAVARI: Record<Tilalaji, string> = {
  kunnossa:   "var(--muste)",
  varoitus:   "var(--varoitus)",
  vika:       "var(--puna)",
  ei_mitattu: "var(--himmea)",
};

export function Tilasana({ laji, children, className, title, style }: {
  laji: Tilalaji;
  /** Pakollinen: tila ilman sanaa tai lukua on tyhjä ruutu. */
  children: ReactNode;
  className?: string;
  title?: string;
  style?: React.CSSProperties;
}) {
  const sisalto = (children === null || children === undefined || children === "")
    ? (laji === "ei_mitattu" ? t("muu.tila.ei_tietoa") : "—")
    : children;
  return (
    <span className={"tila tila--" + laji + (className ? " " + className : "")}
          data-tila={laji} title={title} style={style}>
      {sisalto}
    </span>
  );
}
